import React, { useState } from "react"
import AccountEditForm from "../components/AccountEditForm"
import Header from "../components/Header"
import { Paper } from "@mui/material"
import { spacing } from "../pages/services/styleServices"

const styles = {
    pageContent: {
        margin: spacing(1),
        padding: spacing(1),
    },
}

function AccountEdit(props) {
    const [title, setTitle] = useState("Edit Account")

    return (
        <Header title={title}>
            <Paper sx={styles.pageContent}>
                <AccountEditForm {...props} setTitle={setTitle} />
            </Paper>
        </Header>
    )
}

export default AccountEdit
